import { root } from './seed.js';

function flattenTree(node, map = new Map()) {
  map.set(node.path, node);
  for (const child of node.children ?? []) flattenTree(child, map);
  return map;
}

let _fsMap = flattenTree(root);

export const filesystemState = $state({ ready: false, revision: 0 });

export function getFsMap() { return _fsMap; }
export function resetFsMap(map) { _fsMap = map; }
export { flattenTree };
